import React from 'react'
import Hero from './Hero/Hero'
import Expertise from './Expertise/Expertise'
import Specialize from './Specialize/Specialize'
import Services from './Services/Services'
import Offer from '../Offer/Offer'
import Appointment from './Appointment/Appointment'


const Home = () => {
  return (
    <>
      <Hero/>
      <Expertise/>
     <Specialize/>
     <Services/>
     <Offer/>
     <Appointment/>
    </>
  )
}

export default Home
